import { usePWA } from '@app/hooks/usePWA';
import { useResponsiveNotificationController } from '@app/hooks/useResponsiveNotificationController';
import { useThemeWatcher } from '@app/hooks/useThemeWatcher';

export const useAppBootstrap = (): void => {
  usePWA();
  useThemeWatcher();
  useResponsiveNotificationController();
};
